var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "utxo_container output_container",
    style: {
      backgroundColor: _vm.background
    }
  }, [_c('div', {
    staticClass: "utxo_new_col"
  }, [_c('Summary', {
    attrs: {
      "index": _vm.$vnode.key,
      "utxo": _vm.utxo,
      "is-mint": _vm.isMint,
      "is-p-v-m-export": _vm.isPVMExport,
      "is-export": _vm.isExport,
      "is-atomic-export": _vm.isAtomicExport
    }
  }), _c('Addresses', {
    attrs: {
      "addresses": _vm.utxo.addresses,
      "type": 'output'
    }
  }), _c('LockTime', {
    attrs: {
      "time": _vm.utxo.locktime
    }
  }), _c('Threshold', {
    attrs: {
      "threshold": _vm.utxo.threshold,
      "addresses": _vm.utxo.addresses
    }
  }), _c('Stake', {
    attrs: {
      "is-stake": _vm.utxo.stake
    }
  }), _c('Stakeable', {
    attrs: {
      "is-stakeableout": _vm.utxo.stakeableout,
      "time": _vm.utxo.stakeLocktime
    }
  }), _vm.utxo.genesisutxo === true ? _c('div', [_c('div', [_vm._v("UTXO is from genesis")])]) : _vm._e(), _c('NFTPayload', {
    attrs: {
      "payload": _vm.utxo.payload,
      "asset-i-d": _vm.utxo.assetID,
      "group-i-d": _vm.utxo.groupID
    }
  }), _c('Block', {
    attrs: {
      "block": _vm.utxo.block,
      "nonce": _vm.utxo.nonce
    }
  })], 1), _c('div', {
    staticClass: "tx_link"
  }, [_c('TxLinkOutput', {
    attrs: {
      "tx-i-d": _vm.utxo.redeemingTransactionID,
      "chain-i-d": _vm.utxo.chainID,
      "timestamp": _vm.utxo.timestamp
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }